export interface PaymentButtonConfig {
  initiativeContext?: string;
  style?: ApplePayButtonStyle;
  buttonColor?: string;
  buttonStyle?: string;
  buttonType: string;
  buttonLocale: string;
  buttonSizeMode?: string;
  onPaymentProcessed: (result: IPaymentResult) => void;
  paymentRequest: object | null;
  placement?: string;
}

export enum StatusCode {
  Success = 0,
  Pending = 1,
  Expired = -1,
  Error = -2,
  ServerCallFailed = -3,
  AbortedByUser = -4,
  Failure = -255,
}

export interface IPaymentResult {
  status: StatusCode;
  description: string;
}

export interface ApplePayButtonStyle {
  '--apple-pay-button-width': string;
  '--apple-pay-button-height': string;
  '--apple-pay-button-border-radius': string;
  '--apple-pay-button-padding': string;
}

export interface PaymentIntentSecrets {
  display: string;
  payment: string;
}

export interface PaymentButton {
  isSupported: () => Promise<never>;
  mount: (elementId: string) => void;
  isMounted: boolean;
}

export interface TrustPayApi {
  createComponent: (type: string, config: PaymentButtonConfig) => PaymentButton;
}

export {};
